export const LargeCarouselGetCardColor = (url: string) => {
  const arr: string[] = url?.split('_') || [];
  const colorArr = arr.pop()?.split('.') || [];
  const color = colorArr[0] || '';
  return color;
};
